import { documentToHtmlString } from '@contentful/rich-text-html-renderer'
import Link from 'next/link'
import React, { Fragment } from 'react'
import Markdown from '../common/Markdown'

const SpeechTitles = ({
  label = '',
  speechTitles = [],
  titlesHeading = [],
  titlesDescription = [],
  viewAll = false,
}) => (
  <>
    <h2 className={` text-lg tagline-font whitespace-nowrap py-3 font-bold uppercase`}>{label}</h2>
    <br className="hidden" />
    <div
      className={`flex flex-wrap flex-col text-left order-first h-auto max-w-[20em] text-sm gap-y-3 `}
    >
      {speechTitles?.map((item, index) => (
        <Fragment key={index}>
          {item.url ? (
            <Link href={item.url} legacyBehavior>
              <a target="_blank">
                <p className="hover:underline underline-offset-2 antialiased">{item.title}</p>
              </a>
            </Link>
          ) : (
            <p>{item.title}</p>
          )}
        </Fragment>
      ))}
    </div>
    {titlesHeading?.map((topic, i) => {
      const description = documentToHtmlString(topic.description)
      return (
        <Fragment key={i}>
          {viewAll && (
            <div className="font-semibold text-md pb-2">
              {topic.url ? (
                <Link href={topic.url} legacyBehavior>
                  <a target="_blank">
                    <p className="hover:underline underline-offset-2 antialiased">{topic.title}</p>
                  </a>
                </Link>
              ) : (
                <p> {topic.title}</p>
              )}
            </div>
          )}
          <div className={`inline-block ${viewAll ? 'pb-4' : ''}`}>
            <div className={`text-sm leading-6`} data-cy="speakerDescription">
              {description && (
                <Markdown
                  data={description}
                  isHyperlink={true}
                  isPadding={false}
                  isRichText={true}
                />
              )}
            </div>
          </div>
          {/* <Markdown
            className={`text-xs pb-3 maxSm:pb-2 ${viewAll ? 'pb-4' : ''}`}
            data={description}
            isHyperlink={true}
            isPadding={true}
          /> */}
        </Fragment>
      )
    })}
  </>
)

export default SpeechTitles
